import React from "react";
import "../css/Header.scss";
import { NavLink } from "react-router-dom";

function Header(){
    React.useLayoutEffect(()=>{
        let root = document.querySelector("#root") as HTMLDivElement;
        root.addEventListener("scroll",(ev)=>{
            let topHeader = document.querySelector(".header_top") as HTMLDivElement;
            let currentRootProps = ev.target as HTMLDivElement;
            if(currentRootProps.scrollTop > topHeader.offsetTop/2){
                topHeader.classList.add("header_detached");
            }else{
                topHeader.classList.remove("header_detached");
            }
        })
    })

    return <div className="w-100 app_header">
        <div className="w-100 rd-grid header_mask">
            <div className="rd-xs-12 header_top">
                <span className="text-headline-5 app_title">DataPlus</span>
                <div className="menu">
                    <NavLink to="/" className="text-button menu_item">Accueil</NavLink>
                    <NavLink to="/concept" className="text-button menu_item">Notre concept</NavLink>
                    <NavLink to="/solutions" className="text-button menu_item">Solutions</NavLink>
                    <NavLink to="/contact" className="text-button menu_item">Contact</NavLink>
                    <a target="_blank" href="http://enterprise.dataplus-solutions.tech" className="text-button menu_item">Console</a>
                </div>
            </div>
            <div className=" rd-xs-12 rd-grid rd-gap-2 header_bottom">
                <div className="rd-xs-12 rd-lg-8 description">
                    <span className="text-headline-3">Votre activité cible t'elle l'Afrique?</span>
                    <span className="text-headline-6">
                        Dans un monde ou la satisfaction du client est nécessaire,
                        Améliorez la qualité de vos services en analysant des données réelles variant selon le milieu.
                    </span>
                    <button className="text-button our_mission_btn">Découvrez notre Mission</button>
                </div>
            </div>
        </div>
    </div>
}

export default Header;